/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type V1ApiKeysRerollKeyResponseData = {
  /**
   * Identifier of the new API key.
   */
  keyId: string;
  /**
   * New API key secret, returned only once. Store it securely.
   */
  key: string;
};

/** @internal */
export const V1ApiKeysRerollKeyResponseData$inboundSchema: z.ZodType<
  V1ApiKeysRerollKeyResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  keyId: z.string(),
  key: z.string(),
});

export function v1ApiKeysRerollKeyResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1ApiKeysRerollKeyResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1ApiKeysRerollKeyResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1ApiKeysRerollKeyResponseData' from JSON`,
  );
}
